import { Outlet } from "react-router";
import NavbarDesktop from "./NavbarDesktop/NavbarDesktop";
import NavbarMobile from "./NavbarMobile/NavbarMobile";
import Footer from "./Footer/Footer";
import "@fontsource-variable/cairo-play"; // Supports weights 200-900
import "@fontsource-variable/inter"; // Supports weights 100-900
import "@fontsource-variable/nunito"; // Supports weights 200-900

export default function Layout() {
  return (
    <>
      <NavbarDesktop />
      <NavbarMobile />
      <Outlet />
      <Footer />
    </>
  );
}
